import React, { useEffect, useState } from "react";
import {
  useAddPosition,
  useEmployeeGeoTown,
  useGetEmployeeStatus,
  useGetEODstatus,
  useGetOrgUnitsData,
  useGetPositionById,
  useGetReportingToPositionsByOrgunit,
  useReportingToPositionData,
  useRoles,
  useUpdatePosition,
  useUpdateProfile,
  useUserProfile,
} from "../hooks/useEmployee";
import { Input, Label, Spinner } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getTownFilter } from "../hooks/EmployeeRepository";
import { Use_getUserConfigStatus } from "../../Settings/SuperSettingsScreen/hook/useUserManagement";
import { showToast } from "../../../utils/toastUtils";

const PositionModal = ({ toggleModal, selectedRow, mode, setIsModalOpen }: any) => {
  console.log('modeeeeeeeee',selectedRow)
  const [orgUnit, setOrgUnit] = useState("");
  const [reportingTo, setReportingTo] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [HQTown, setHQTown] = useState<any>("");
  const [status, setStatus] = useState("");


  const { data: PositionById } = useGetPositionById({
    id: selectedRow?.PositionId,
    enabled: Boolean(mode === "edit"),
  });
  const { data: orgUnitList } = useGetOrgUnitsData({
    enable: true,
  });

  const { data: ReportingTo } = useGetReportingToPositionsByOrgunit({
    id: orgUnit|| PositionById?.data?.OrgUnitId,
    enabled: Boolean(orgUnit || (mode === "edit" && PositionById?.data?.OrgUnitId)),
  });

  const{data:mtptype}=Use_getUserConfigStatus({
    enable:true
  })
  console.log("mtptype status",mtptype?.rowData?.data.MtpType)

  const formattedMtpType=Object.keys(mtptype?.rowData?.data.MtpType||{}).map((item)=>({
    id:item,
    label:mtptype?.rowData?.data.MtpType[item]
  }))
  console.log('formattedMtpType',formattedMtpType)


  useEffect(() => {
    if (mode === "edit" && PositionById?.data) {
      const position = PositionById.data;
      setOrgUnit(position.OrgUnitId || "");
      setReportingTo(position.ReportingTo || "");
      setName(position.PositionName || "");
      setCode(position.PositionCode || "");
      setHQTown({ id: position.Itownid, label: position.GeoTowns });
      setStatus(position.MtpType?.toString() || "");
    }
  }, [mode,PositionById]);

  const FormattedDataorgunit = Object.keys(orgUnitList?.data || {})
    .map((item: any) => ({
      id: orgUnitList?.data[item].id,
      label: orgUnitList?.data[item].label,
    }))
    .slice(1); // Removing the first element as requested

  const FormattedDataReportingTo = 
    ReportingTo?.data?.positions?.map((item: any) => ({
    id: item.PositionId,
    label: item.PositionName,
  }));
const {mutate:addPosition,isPending:isSubmit}=useAddPosition()
const {mutate:updatePosition,isPending:isUpdate}=useUpdatePosition()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

 if (!orgUnit) {
    showToast.warning("Orgunit is required");
    return;
  }
   if (!reportingTo) {
      showToast.warning("ReportingTo is required");
      return;
    }
     if (!name) {
        showToast.warning("Position name is required");
        return;
      }
       if (!code) {
          showToast.warning("Position code is required");
          return;
        }
         if (!HQTown) {
            showToast.warning("Town is required");
            return;
          }
    
    const payload = {
      OrgUnitId: orgUnit,
      ReportingTo:reportingTo,
      PositionName: name,
      PositionCode: code,
      Itownid:HQTown.id,
      MtpType:status,
    };
 if(mode=='edit'){
  updatePosition({ reqBody: payload, id: selectedRow.PositionId},{onSuccess:()=>setIsModalOpen(false)});

 }else{

   addPosition(payload,{onSuccess:()=>setIsModalOpen(false)})
 }


  };
const isLoading =
  !orgUnitList?.data ||
  (mode === "edit" && (!PositionById?.data || !ReportingTo?.data));
  return (
  <> 
   {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) : (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-md-6">
          <RouteDropdown
            DropdownHeading="Org Unit*"
            value={orgUnit}
            onChange={(value: any) => setOrgUnit(value)}
            options={FormattedDataorgunit || []}
          />
        </div>
        <div className="col-md-6">
          <RouteDropdown
            value={reportingTo}
            DropdownHeading="Reporting To*"
            options={ FormattedDataReportingTo|| []}
            onChange={(value: any) => setReportingTo(value)}
          />
        </div>

        <div className="col-md-6">
          <Label className="col-form-label">Position Name*</Label>
          <div className="form-input position-relative">
            <Input
              placeholder="Enter Position Name"
              onChange={(event) => setName(event.target.value)}
              value={name}
            />
          </div>
        </div>

        <div className="col-md-6">
          <Label className="col-form-label">Position Code*</Label>
          <div className="form-input position-relative">
            <Input
              type="number"
              placeholder="Enter Code"
              onChange={(event) => setCode(event.target.value)}
              value={code}
            />
          </div>
        </div>

        <div className="col-md-6">
          <PaginatedRouteDropdown
            initialSelectedOptions={HQTown}
            DropdownHeading="Towns*"
            placeholder="Select Towns"
            fetchOptions={async (page: any, search: any) => {
              const res = await getTownFilter({
                page,
                limit: 10,
                search: search || "",
              });
              return Object.keys(res?.data?.TownsData || {}).map((item) => ({
                id: item,
                label: res?.data?.TownsData[item],
              }));
            }}
            onChange={(val: any) => setHQTown(val)}
          />
        </div>
        <div className="col-md-6">
          <RouteDropdown
            value={status}
            DropdownHeading="MTP Type"
            options={ formattedMtpType|| []}
            onChange={(value: any) => setStatus(value)}
          />
        </div>
      </div>

      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn style={{ backgroundColor: "#43B9B2", color: "white" }} type="submit"
        disabled={isSubmit||isUpdate}>
          {mode === "edit"
    ? isUpdate
      ? "Updating..."
      : "Update"
    : isSubmit
    ? "Submitting..."
    : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={() => setIsModalOpen(false)}
        >
          Cancel
        </Btn>
      </div>
    </form>
)
}
  </>
  )
}

export default PositionModal;
